import { env } from '@configuration/env';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(env.BASE_URL),
  routes: [],
  scrollBehavior(to, from, savedPosition): any {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
